import { render } from "./SamplesBox.vue?vue&type=template&id=768d25b3&scoped=true&ts=true"
import script from "./SamplesBox.vue?vue&type=script&lang=ts"
export * from "./SamplesBox.vue?vue&type=script&lang=ts"

import "./SamplesBox.vue?vue&type=style&index=0&id=768d25b3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768d25b3"]])

export default __exports__